/**
 * SettingsPanel - панель настроек секции
 *
 * Чистая версия без дублирования:
 * - Header в SettingsDrawer
 * - Удаление в SectionToolbar
 */
import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { getSectionSettings, getSectionSchema } from '../../../sections';
import { CommonSettings, AutoSettings } from '../../../sections/components/settings';

const SettingsPanel = ({
  selectedSection,
  onUpdateSection,
  allSections = [],
  allPages = [],
  projectId
}) => {
  const [activeTab, setActiveTab] = useState('content');

  if (!selectedSection) {
    return (
      <div className="flex flex-col items-center justify-center p-8 text-center">
        <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center mb-3">
          <Icon name="MousePointer" size={24} className="opacity-40" />
        </div>
        <p className="text-sm text-text-secondary">
          Выберите секцию на canvas
        </p>
      </div>
    );
  }

  const handleContentChange = (newContent) => {
    onUpdateSection(selectedSection.id, {
      ...selectedSection,
      content: newContent
    });
  };

  const handleSectionChange = (updatedSection) => {
    onUpdateSection(selectedSection.id, updatedSection);
  };

  // Получаем Settings компонент или schema для AutoSettings
  const CustomSettings = getSectionSettings(selectedSection.type);
  const schema = getSectionSchema(selectedSection.type);

  const tabs = [
    { id: 'content', label: 'Контент', icon: 'Type' },
    { id: 'style', label: 'Стиль', icon: 'Palette' },
  ];

  return (
    <div className="flex flex-col h-full">
      {/* Tabs */}
      <div className="flex border-b border-border">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex-1 flex items-center justify-center gap-2 py-3 text-sm font-medium transition-colors ${
              activeTab === tab.id
                ? 'text-primary border-b-2 border-primary -mb-px'
                : 'text-text-secondary hover:text-foreground'
            }`}
          >
            <Icon name={tab.icon} size={16} />
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-4">
        {activeTab === 'content' && (
          <div className="space-y-6">
            {CustomSettings ? (
              <CustomSettings
                data={selectedSection.content || {}}
                onChange={handleContentChange}
                allSections={allSections}
                allPages={allPages}
                projectId={projectId}
              />
            ) : schema?.fields ? (
              <AutoSettings
                schema={schema}
                data={selectedSection.content || {}}
                onChange={handleContentChange}
                allSections={allSections}
                allPages={allPages}
                projectId={projectId}
              />
            ) : (
              <div className="text-center py-8">
                <Icon name="FileQuestion" size={32} className="mx-auto mb-2 opacity-30" />
                <p className="text-sm text-text-secondary">
                  Настройки контента недоступны
                </p>
              </div>
            )}
          </div>
        )}

        {activeTab === 'style' && (
          <CommonSettings
            section={selectedSection}
            onChange={handleSectionChange}
            category={schema?.category}
          />
        )}
      </div>
    </div>
  );
};

export default SettingsPanel;
